import { useFormik } from 'formik'
import React, { useState, useEffect } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import BaseButton from '../components/Base/BaseButton'
import BaseInput from '../components/Base/BaseInput'
import BaseTermOfService from '../components/Base/BaseTermOfService'
import { authService } from '../services/auth'
import Promotion from 'src/components/Promotion/Promotion'

const SignUp = () => {
    const history = useHistory()
    const [agree1, setAgree1] = useState(false)
    const [agree2, setAgree2] = useState(false)
    const [agree3, setAgree3] = useState(false)

    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const coupon = queryParams.get('code') ?? ''

    const [couponStored, setCouponStored] = useState<boolean>(
        localStorage.getItem('coupon') ? true : false
    )
    const [couponCode, setCouponCode] = useState<string | null>(
        localStorage.getItem('coupon') ? localStorage.getItem('coupon') : ''
    )
    const [couponValue, setCouponValue] = useState<string | null>(
        localStorage.getItem('coupon_value')
            ? localStorage.getItem('coupon_value')
            : ''
    )

    const { isSubmitting, handleChange, handleSubmit } = useFormik({
        initialValues: {
            email: '',
            password: '',
            confirmPassword: '',
            phoneNumber: '',
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                const res = await authService.signUp(values)

                if (res.data) {
                    toast.info(res.message)

                    const { phoneNumber, verificationToken } = res.data
                    history.push(
                        `/verify/phone?phone=${phoneNumber}&t=${verificationToken}`
                    )
                }
            } catch ({ message }: any) {
                setSubmitting(false)

                toast.error(message as string)
            }
        },
    })

    useEffect(() => {
        if (coupon) {
            const deccoded = Buffer.from(String(coupon), 'base64').toString()
            const splited = deccoded.split('|')

            if (/^[0-9]+$/.test(splited[1])) {
                localStorage.setItem('coupon', splited[0])
                localStorage.setItem('coupon_value', splited[1])

                setCouponCode(splited[0])
                setCouponValue(splited[1])
                setCouponStored(true)
            }
        }
    }, [coupon])

    return (
        <form autoComplete="off" onSubmit={handleSubmit}>
            <BaseInput
                type="email"
                name="email"
                label="อีเมล"
                required
                onChange={handleChange}
            />
            <BaseInput
                type="password"
                name="password"
                label="รหัสผ่าน"
                required
                onChange={handleChange}
            />
            <BaseInput
                type="password"
                name="confirmPassword"
                label="ยืนยันรหัสผ่าน"
                required
                onChange={handleChange}
            />
            <BaseInput
                type="text"
                name="phoneNumber"
                label="เบอร์โทรศัพท์"
                required
                onChange={handleChange}
            />

            {couponStored && (
                <Promotion coupon={couponCode} couponValue={couponValue} />
            )}

            <div className="form-group">
                <BaseTermOfService
                    to="/refund-policy"
                    custom_text2="นโยบายคืนเงิน"
                    state={[agree1, setAgree1]}
                />
            </div>
            <div className="form-group">
                <BaseTermOfService
                    to="/term-of-service"
                    state={[agree2, setAgree2]}
                />
            </div>
            <div className="form-group">
                <BaseTermOfService
                    to="/privacy-and-data-protection-policy"
                    custom_text2="นโยบายความเป็นส่วนตัวและการคุ้มครองข้อมูล"
                    state={[agree3, setAgree3]}
                />
            </div>
            <div className="form-group mt-1 auth-submit-group">
                <BaseButton
                    type="submit"
                    color="primary"
                    classes="mr-2"
                    loading={isSubmitting}
                    disabled={!agree1 || !agree2 || !agree3}
                >
                    สมัครสมาชิก
                </BaseButton>

                <span>
                    มีบัญชีแล้ว? <Link to="/sign-in">เข้าสู่ระบบ</Link>
                </span>
            </div>
        </form>
    )
}

export default SignUp
